<template>
    <div v-if="isMounted" class="announcement-overlay">
        <transition name="announcement-panel-slide">
            <section v-if="isVisible" class="announcement-panel">
                <div class="announcement-panel__image">
                    <a v-if="hasAdvertisementUrl" :href="advertisementUrl" target="_blank" rel="noopener noreferrer">
                        <img :src="imagePath" alt="Anuncio Premium"/>
                    </a>
                    <img v-else :src="imagePath" alt="Anuncio Premium"/>
                </div>

                <div class="announcement-panel__actions">
                    <button type="button" class="announcement-panel__close" @click="onClose">
                        Cerrar
                    </button>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AnuncioPremium',
    data() {
        return {
            isMounted: false,
            isVisible: false,
            advertisement: null,
        }
    },
    computed: {
        imagePath() {
            if (this.advertisement != null && this.advertisement.path != null) {
                return `${this.advertisement.path}`.trim();
            }

            return '';
        },
        advertisementUrl() {
            if (this.advertisement != null && this.advertisement.url != null) {
                return `${this.advertisement.url}`.trim();
            }

            return '';
        },
        hasAdvertisementUrl() {
            return this.advertisementUrl !== '';
        },
    },
    methods: {
        onClose() {
            this.isVisible = false;
            window.setTimeout(() => {
                this.isMounted = false;
            }, 650);
        },
        showAdvertisement(advertisement) {
            this.advertisement = advertisement;

            if (this.imagePath === '') {
                return;
            }

            this.isMounted = true;

            this.$nextTick(() => {
                window.setTimeout(() => {
                    this.isVisible = true;
                }, 250);
            });
        },
    },
    mounted() {
        axios.get('advertisement/dropdown')
            .then(response => {
                if (response.data && response.data.path) {
                    this.showAdvertisement(response.data);
                }
            })
            .catch(() => {});
    },
}
</script>

<style scoped>
.announcement-overlay {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999998;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    background: #ffffff;
}

.announcement-panel {
    width: min(720px, 100%);
    max-height: calc(100vh - 32px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 8px;
}

.announcement-panel__image {
    width: 100%;
    max-height: calc(100vh - 120px);
    overflow: auto;
    padding: 32px 28px 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
}

.announcement-panel__image img {
    width: 100%;
    height: auto;
    display: block;
    max-width: 520px;
    max-height: calc(100vh - 180px);
    object-fit: contain;
}

.announcement-panel__image a {
    display: block;
    width: 100%;
    max-width: 520px;
}

.announcement-panel__actions {
    padding: 0 24px 24px;
    display: flex;
    justify-content: center;
    background: #ffffff;
}

.announcement-panel__close {
    min-width: 140px;
    border: 0;
    color: #ffffff;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    border-radius: 5px;
    padding: 13px 28px;
    background: #cc9933;
}

.announcement-panel-slide-enter-active,
.announcement-panel-slide-leave-active {
    transition: transform 0.65s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.35s ease;
}

.announcement-panel-slide-enter,
.announcement-panel-slide-leave-to {
    opacity: 0;
    transform: translateY(-120vh);
}
</style>
